import { render, staticRenderFns } from "./consumeConfirm.vue?vue&type=template&id=2471e9f5&scoped=true"
import script from "./consumeConfirm.vue?vue&type=script&lang=js"
export * from "./consumeConfirm.vue?vue&type=script&lang=js"
import style0 from "./consumeConfirm.vue?vue&type=style&index=0&id=2471e9f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2471e9f5",
  null
  
)

export default component.exports